import { Flex, Text, TextInput } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors, Sizes } from "@jsq/ds/styles";
import { ArenaLockAction } from "../constants";
import { validateEmail } from "../utils";
import * as styles from "./styles_vanilla.css";

type EmailInputProps = {
  selectedAction: ArenaLockAction;
  email: string;
  emailError: string;
  onEmailChange: (email: string) => void;
  onEmailErrorChange: (error: string) => void;
};

export const EmailInput = ({
  selectedAction,
  email,
  emailError,
  onEmailChange,
  onEmailErrorChange,
}: EmailInputProps) => {
  return (
    <div className={styles.userInfoSection}>
      <Flex alignItems="center" gap={Sizes.SM} className={styles.sectionHeaderFlex}>
        <Icon type="user" size="medium" color={Colors.Primary600} />
        <Text variant="strong-md" className={styles.sectionTitle}>
          Operation Executor
        </Text>
      </Flex>
      <Text variant="secondary-md" className={styles.userInfoDescription}>
        Enter the email address of the user who will execute this {selectedAction} operation:
      </Text>
      <Text variant="secondary-sm" className={styles.requiredFieldText}>
        * Required field
      </Text>

      <div className={styles.emailInput}>
        <TextInput
          type="email"
          placeholder="user@domain.com (required)"
          value={email}
          onChange={(e) => {
            const newEmail = e.target.value;
            onEmailChange(newEmail);
            if (emailError && newEmail.trim()) {
              const error = validateEmail(newEmail);
              onEmailErrorChange(error);
            } else if (emailError) {
              onEmailErrorChange("");
            }
          }}
          onBlur={() => {
            const error = validateEmail(email);
            onEmailErrorChange(error);
          }}
          errorMessage={emailError || undefined}
          isFullWidth
          required
        />
      </div>

      <Text variant="secondary-sm" className={styles.userInfoNote}>
        Please ensure the specified user has the necessary permissions to perform this
        operation.
      </Text>
    </div>
  );
};
